var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import memoize from 'lodash/memoize';
import { createSelectorCreator } from 'reselect';
import Item from './item';
var hashFn = function (row) { return row.collection + row.id + row.title; };
// TODO any!
var createPersistentSelector = createSelectorCreator(memoize, hashFn);
export var extendedSearchRowSelector = createPersistentSelector(function (row) { return row; }, function (row) { return (__assign(__assign({}, row), { childKey: "" + row.id, as: Item })); });
